import Page from './index';

export default { path: '/home/msgChannelSourceManage', component: Page };
